import { createRouter, createWebHistory } from "vue-router";
import Home from "../components/Home.vue"; 

const router = createRouter({
  history: createWebHistory(),

  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/projects",
      name: "ProjectGrid",
      component: Home,
    },
    {
      path: "/vfx",
      name: "VFXGrid",
      component: Home,
    },
    {
      path: "/contact",
      name: "ContactModule",
      component: Home,
    },

    {
      path: "/project/:id",
      name: "ProjectDetail",
      component: () => import("../components/ProjectDetail.vue"),
      props: true,
    },
  ],
});

export default router;
